import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  getCurrentPosition(): Observable<GeolocationPosition> {
    return new Observable<GeolocationPosition>(observer => {
      if (!navigator.geolocation) {
        observer.error('Geolocation não é suportado pelo navegador.');
        observer.complete();
        return;
      }

      navigator.geolocation.getCurrentPosition(
        position => {
          observer.next(position);
          observer.complete();
        },
        error => {
          observer.error(error);
        },
      );
    });
  }
}
